import * as React from "react";
import { ShieldCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const rightsFaqs = [{
  id: "consent",
  question: "Diritto di prestare o revocare il consenso",
  answer: "Hai il diritto di scegliere quali categorie di cookie accettare. Puoi modificare le tue preferenze o revocare il consenso in qualsiasi momento accedendo al pannello di controllo dei cookie, solitamente disponibile nel footer del sito."
}, {
  id: "browser",
  question: "Gestione tramite le impostazioni del browser",
  answer: "Indipendentemente dalle opzioni offerte dal nostro sito, hai il diritto di configurare il tuo browser web per accettare o rifiutare tutti i cookie, o per ricevere un avviso quando un cookie viene impostato. La disabilitazione totale dei cookie potrebbe limitare alcune funzionalità del sito."
}, {
  id: "information",
  question: "Diritto a un'informativa trasparente",
  answer: "Hai il diritto di sapere esattamente quali cookie utilizziamo, per quali scopi e per quanto tempo vengono conservati i tuoi dati. Tutte queste informazioni sono dettagliate nella nostra Cookie Policy completa."
}, {
  id: "third-party",
  question: "Controllo sui cookie di terze parti",
  answer: "Per i cookie gestiti da servizi esterni (come strumenti di analisi o plugin social), hai il diritto di opporti al loro utilizzo. Puoi farlo tramite il nostro pannello di controllo o visitando le privacy policy delle rispettive terze parti linkate nella nostra informativa."
}, {
  id: "deletion",
  question: "Diritto alla cancellazione (Diritto all'oblio)",
  answer: "Puoi richiedere la cancellazione dei dati personali raccolti tramite cookie non essenziali. Per esercitare questo diritto, puoi contattarci direttamente utilizzando i recapiti forniti nella nostra Privacy Policy."
}];
export default function UserRightsControls() {
  return <section id="user-rights-controls" className="bg-background py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6 max-w-3xl">
        <div className="flex flex-col items-center text-center mb-12">
          <div className="inline-flex items-center justify-center p-3 bg-primary/10 rounded-full mb-6 text-primary">
            <ShieldCheck className="w-8 h-8" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold font-default text-foreground mb-4">
            Diritti e Controlli dell'Utente
          </h2>
          <p className="text-lg text-muted-foreground font-sans max-w-2xl">
            La tua privacy è importante per noi. Di seguito ti spieghiamo in modo
            chiaro e trasparente quali sono i tuoi diritti riguardo all'uso dei
            cookie su questo sito e come puoi esercitarli.
          </p>
        </div>

        <div className="bg-card border border-border rounded-xl shadow-sm p-6 md:p-8">
          <Accordion type="single" collapsible className="w-full">
            {rightsFaqs.map((faq, index) => <AccordionItem key={faq.id} value={faq.id} data-index={index}>
                <AccordionTrigger className="text-left font-default text-lg text-foreground hover:text-primary">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="font-sans text-base text-muted-foreground leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>

        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button asChild variant="default" size="lg" className="w-full sm:w-auto font-sans">
            <Link to="#">
              Leggi la Cookie Policy Completa
            </Link>
          </Button>
          <Button asChild variant="outline" size="lg" className="w-full sm:w-auto font-sans">
            <Link to="#">
              Contattaci per Assistenza
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}